import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useImperativeHandle, useRef } from "react";
import { stringToParsedTokenArray } from "@poscon/shared-types/eram";
import { CLEAR_WEATHER_SYMBOL } from "@poscon/shared-types";
import { useDispatch } from "react-redux";
import { eramFontDimensionMap, eramFontNameMap, getBitmapTextStyles } from "../../eramFont.js";
import { useRootSelector } from "../stateSelectors.js";
import { selectedAdvisorySelector, setSelectedAdvisory } from "../slices/commonSlice.js";
import { colorNameMap } from "../../colorNameMap.js";
import { EramInput, useInputProps } from "./EramInput.js";
import { EramPrompt } from "./EramPrompt.js";
import { useCenterCursor } from "../hooks/useCenterCursor.js";
import { MenuElement } from "./MenuElement.js";
export const advCreationTemplateView = "ADV_CREATION_TEMPLATE";
const maxNameLength = 16;
const msgRowWidth = 35;
const maxMsgLength = 497;
const fontFamily = eramFontNameMap[2];
const fontDim = eramFontDimensionMap[fontFamily];
export const advCreateWidth = (7 + msgRowWidth) * fontDim.width;
export const AdvCreateTemplate = ({ dispatchCommand, ref, ...promptProps }) => {
    const localRef = useRef(null);
    const dispatch = useDispatch();
    const selectedAdv = useRootSelector(selectedAdvisorySelector);
    const nameInputProps = useInputProps(`${advCreationTemplateView}/name`, selectedAdv?.name ?? "", undefined, {
        maxLength: maxNameLength,
        focusOnMount: true,
    });
    const msgInputProps = useInputProps(`${advCreationTemplateView}/message`, selectedAdv?.message ?? "", undefined, {
        initialCursorPos: (selectedAdv?.message ?? "").length,
        maxLength: maxMsgLength,
        focusOnMount: false,
        pasteOnTBE: true,
    });
    useCenterCursor(localRef);
    const saveAdv = () => {
        dispatchCommand(stringToParsedTokenArray(`UM /S ${nameInputProps.value}${CLEAR_WEATHER_SYMBOL} ${msgInputProps.value}`));
        dispatch(setSelectedAdvisory(null));
    };
    const msgHeight = fontDim.height * Math.max(5, Math.ceil(msgInputProps.value.length / msgRowWidth)) + 4;
    const height = 18 + fontDim.height * 2 + msgHeight;
    useImperativeHandle(ref, () => {
        return localRef.current;
    }, []);
    return (_jsxs(EramPrompt, { ref: localRef, title: "ADV CREATION/EDIT TEMPLATE", width: advCreateWidth, height: height, closeMenu: () => {
            dispatch(setSelectedAdvisory(null));
        }, showX: true, ...promptProps, children: [_jsx("bitmapText", { eventMode: "none", x: 4, y: 3, text: "NAME", style: { ...getBitmapTextStyles(fontFamily), fill: colorNameMap.lightGrey } }), _jsx("bitmapText", { eventMode: "none", x: 4, y: fontDim.height + 8, text: "TEXT", style: { ...getBitmapTextStyles(fontFamily), fill: colorNameMap.lightGrey } }), _jsxs("container", { x: fontDim.width * 5, y: 3, children: [_jsx(EramInput, { width: fontDim.width * maxNameLength + 4, height: fontDim.height + 2, borderTint: colorNameMap.darkGrey, highlightColor: colorNameMap.white, ...nameInputProps }), _jsx(EramInput, { y: fontDim.height + 5, width: fontDim.width * msgRowWidth + 4, height: msgHeight, chunkSize: msgRowWidth, borderTint: colorNameMap.darkGrey, highlightColor: colorNameMap.white, ...msgInputProps })] }), _jsx(MenuElement, { x: (advCreateWidth - fontDim.width * 2 - 2) / 2, y: height - fontDim.height, text: "SAVE", onmousedown: saveAdv })] }));
};
//# sourceMappingURL=AdvCreateTemplate.js.map